import request from '../../utils/request'

// 查询
export function home ({mark}) {
  return request.post(`/home/home?mark=${mark}`)
}
// 查询
export function homeShop ({mark}) {
  return request.post(`/home/homeShop?mark=${mark}`)
}
